function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0001,
  cy: 6.46154,
  r: 6.46154,
  fill: "#DE9EFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9761 7.87891C12.7701 7.87891 13.4136 7.23532 13.4136 6.44141C13.4136 5.6475 12.7701 5.00391 11.9761 5.00391C11.1822 5.00391 10.5386 5.6475 10.5386 6.44141C10.5386 7.23532 11.1822 7.87891 11.9761 7.87891Z",
  stroke: "#012CAD",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.45947 18.8984C6.25338 18.8984 6.89697 18.2549 6.89697 17.4609C6.89697 16.6671 6.25338 16.0234 5.45947 16.0234C4.66556 16.0234 4.02197 16.6671 4.02197 17.4609C4.02197 18.2549 4.66556 18.8984 5.45947 18.8984Z",
  stroke: "#012CAD",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.397 18.8984C19.1909 18.8984 19.8345 18.2549 19.8345 17.4609C19.8345 16.6671 19.1909 16.0234 18.397 16.0234C17.6031 16.0234 16.9595 16.6671 16.9595 17.4609C16.9595 18.2549 17.6031 18.8984 18.397 18.8984Z",
  stroke: "#012CAD",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3541 20.6248C17.0791 22.3498 19.7624 22.3498 21.4874 20.6248C23.2124 18.8998 23.2124 16.2165 21.4874 14.4915C20.0499 13.054 17.8457 12.8623 16.2166 13.8206L12.6006 7.73047",
  stroke: "#012CAD",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.28542 13.3398C2.56042 13.819 1.21875 15.544 1.21875 17.4607C1.21875 19.8565 3.13542 21.7732 5.53125 21.7732C7.92708 21.7732 9.84375 19.8565 9.84375 17.4607H16.9649",
  stroke: "#012CAD",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1927 7.59219C16.4802 6.15469 16.0968 4.62135 15.0427 3.56719C13.3177 1.84219 10.6343 1.84219 8.90934 3.56719C6.99267 5.57969 7.28017 8.83802 9.77184 10.3714L6.33569 16.3149",
  stroke: "#012CAD",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconWebhook2Color(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebhook2Color);
export default __webpack_public_path__ + "static/media/icon-webhook-2color.2e37c177234291e3cddb9fa4cf4f452f.svg";
export { ForwardRef as ReactComponent };